import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'

// Global hata yakalayicilari — backend'e log gonder
function _reportFrontError(payload) {
  try {
    const u = JSON.parse(localStorage.getItem('user') || 'null')
    fetch('/api/log-frontend-error', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...payload, path: window.location.pathname + window.location.search, user: u?.username || null }),
      keepalive: true,
    }).catch(() => {})
  } catch {}
}
window.addEventListener('error', (e) => {
  _reportFrontError({
    name: e.error?.name || 'Error',
    message: e.message || String(e.error || e),
    stack: (e.error?.stack || '').split('\n').slice(0, 20).join('\n'),
    context: 'window.error',
  })
})
window.addEventListener('unhandledrejection', (e) => {
  const r = e.reason
  _reportFrontError({
    name: r?.name || 'UnhandledRejection',
    message: r?.message || String(r),
    stack: (r?.stack || '').split('\n').slice(0, 20).join('\n'),
    context: 'unhandledrejection',
  })
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
)
